import { parseCountry } from "helpers/experiment";
import { resolvePricingCatalogVersion } from "helpers/experimentConfig";

import type { CountryGroup, ExperimentBucket } from "helpers/experiment";

const REFERRAL = /^[A-Za-z0-9_.@ -]{1,64}$/;

/**
 * An influencer `ref` query value in the shape the discounts resolver keys on,
 * or null. Anything else is dropped rather than forwarded, so a junk query
 * string cannot fan the upstream catalogue out into one variant per visitor.
 */
export function parseReferral(
  value: string | string[] | null | undefined,
): string | null {
  const ref = (Array.isArray(value) ? value[0] : value)?.trim().toLowerCase();
  return ref && REFERRAL.test(ref) ? ref : null;
}

// Every locale, `en` included, takes the locale-in-path route: it is the only
// one iv-pro-api overlays auto-applied discounts on, and the legacy bare
// `/detailed` URL stays byte-frozen upstream. The site sells through the
// `invideo` store only (the gateway then defaults to stripe_us); the country
// group and an influencer `ref` select which offer the visitor gets. `country`
// (Worker-stamped ISO2) lets the API reprice to EUR for stripe_eu visitors; it
// only changes display, checkout picks its gateway from the request IP.
export function pricingPlansPath(
  locale?: string,
  _bucket?: ExperimentBucket | null,
  countryGroup?: CountryGroup | null,
  referral?: string | null,
  country?: string | null,
): string {
  const query = new URLSearchParams({ store: "invideo" });
  if (countryGroup) query.set("country_group", countryGroup);
  const isoCountry = parseCountry(country);
  if (isoCountry) query.set("country", isoCountry);
  if (referral) query.set("ref", referral);
  return `/api/plans/${resolvePricingCatalogVersion(countryGroup)}/detailed/${locale || "en"}?${query}`;
}
